import Cookies from 'js-cookie'

const TokenKey = 'obia_token'

export function getToken () {
  // console.log("获取 token");
  return Cookies.get(TokenKey)
}
export function setToken (token) {
  // demo是网站的二级目录，请修改为自己对应的网站名称
  return Cookies.set(TokenKey, token, { path: '/obia' })
}

export function removeToken () {
  // 如果设置cookie时指定了domain，在删除时需要在前面加.前缀，既是：".ngdc.cncb.ac.cn"
  // Cookies.remove(TokenKey, { path: "/demo", domain: ".ngdc.cncb.ac.cn" });

  // 如果设置cookie时没有指定domain，在删除时不能带domain配置，demo是网站的二级目录，请修改为自己对应的网站名称
  // Cookies.remove(TokenKey, { path: "/obia" });
  Cookies.remove(TokenKey, { path: '/obia' })
}

// TODO
export function login () {
  // 原始
  window.location.href =
    // "https://ngdc.cncb.ac.cn/sso/login?service=https://ngdc.cncb.ac.cn/demo/api/login";
    // 本地
    // 'http://192.168.164.84:9131/sso/login?service=http://localhost:8081/obia/api/login'
    // 服务器
    // 'http://192.168.164.84:9131/sso/login?service=http://192.168.164.20:8081/obia/api/login'
    // 'http://192.168.164.84:9131/sso/login?service=http://192.168.164.104:8081/obia/api/login'
    // 上线
    'https://sso.cncb.ac.cn/login?service=https://ngdc.cncb.ac.cn/obia/api/login'
}

export function register () {
  window.open('https://sso.cncb.ac.cn/account/register/personal?service=https://ngdc.cncb.ac.cn/obia/register', '_blank')
  // https://ngdc.cncb.ac.cn/account/register?service=https://ngdc.cncb.ac.cn/obia/register
  // https://192.168.164.84:9131/account/register?service=https://ngdc.cncb.ac.cn/obia/register
}

export function userProfile () {
  window.open('https://sso.cncb.ac.cn/account/api/go-user-profile?service=https://ngdc.cncb.ac.cn/obia/logout', '_blank')
  // window.open('https://sso.cncb.ac.cn/account/api/go-user-profile?service=https://ngdc.cncb.ac.cn/obia/logout', '_blank')
  // https://ngdc.cncb.ac.cn/account/user-profile?service=https://ngdc.cncb.ac.cn/obia/logout
  // https://192.168.164.84:9131/account/user-profile?service=https://ngdc.cncb.ac.cn/obia/logout
}

// TODO
export function logout () {
  // 删除token
  removeToken()
  // 跳转前端首页？
  window.location.href =
    // "https://ngdc.cncb.ac.cn/sso/logout?service=https://ngdc.cncb.ac.cn/demo/";
    // 本地
    // 'http://192.168.164.84:9131/sso/logout?service=http://localhost:8080/obia/'
    // 服务器
    // 'http://192.168.164.84:9131/sso/logout?service=http://192.168.164.20:8000/obia/'
    // 'http://192.168.164.84:9131/sso/logout?service=http://192.168.164.104:8000/obia/'
    // 上线
    'https://sso.cncb.ac.cn/logout?service=https://ngdc.cncb.ac.cn/obia/'
}



// WEBPACK FOOTER //
// ./src/utils/auth.js